<script setup>
import { useRoute } from "vue-router";
import { ref, onMounted } from 'vue';
// import { useStore } from "@/stores/index";
import { usePortfoliosStore } from "@/stores/portfolios"
 
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
// import SidenavCard from "./SidenavCard.vue";
// import SidenavCollapseItem from "./SidenavCollapseItem.vue";

// const store = useStore();
const portfoliosStore = usePortfoliosStore();

const portfolios = ref([]);

onMounted(async () => {
  
  // Or if you're using a store:
  await portfoliosStore.fetchPortfolios();
  portfolios.value = portfoliosStore.portfolios;
  
});

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div id="sidenav-collapse-main" class="collapse navbar-collapse w-auto h-auto h-100">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse collapse-ref="dashboardsExamples" nav-text="Dashboard" :class="getRoute() === 'dashboards' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-shop text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <sidenav-item :to="{ name: 'Default' }" mini-icon="D" text="Home" />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      

      <!-- PAGES -->
      <!-- <li class="nav-item">
        <sidenav-collapse nav-text="Portfolios" class="no-link-nav"></sidenav-collapse>
      </li> -->
      <hr class="mt-0 horizontal dark"/>
        <p style="margin: 0px 0.5rem;
                  padding: 1rem 1rem 1rem;
                  background: #e5f6f8;
                  border-radius: 5px;
                  color: #344767;" 
            class="text-center text-sm ms-2 font-weight-bold">
          Portfolios
        </p>
        <!-- Dynamic Menu -->
        <li v-for="portfolio in portfolios" :key="portfolio.id" class="nav-item">
          <sidenav-collapse 
            :collapse-ref="`portfolio-${portfolio.id}`" 
            :nav-text="portfolio.Name" 
            :class="getRoute() === 'pages' ? 'active' : ''"
            :aria-expanded="false"
          >
            <template #icon>
              <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
            </template>
            <template #list>
              <ul class="nav ms-4">
                <sidenav-item 
                  :to="{ path: `/pages/annual-financials/${portfolio.id}` }" 
                  mini-icon="A" 
                  text="Annual Financials" 
                />
                <sidenav-item 
                  :to="{ path: `/pages/financial-models/${portfolio.id}` }" 
                  mini-icon="F" 
                  text="Financial Models" 
                />
                <sidenav-item 
                  :to="{ path: `/pages/quarterly-reports/${portfolio.id}` }" 
                  mini-icon="Q" 
                  text="Quarterly Reports" 
                />
              </ul>
            </template>
          </sidenav-collapse>
        </li>
      <hr class="mt-4 mb-0 horizontal dark"/>
      <!-- Static Menu -->
      <!-- <li class="nav-item">
        <sidenav-collapse collapse-ref="pagesExamples" nav-text="Senditoo" :class="getRoute() === 'pages' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <sidenav-item :to="{ path: '/pages/annual-financials/2' }" mini-icon="A" text="Annual Financials" />
              <sidenav-item :to="{ path: '/pages/financial-models/2' }" mini-icon="F" text="Financial Models" />
              <sidenav-item :to="{ path: '/pages/quarterly-reports/2' }" mini-icon="Q" text="Quarterly Reports" />
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse collapse-ref="pagesExamples" nav-text="TallOrder (CloudOne)" :class="getRoute() === 'pages' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <sidenav-item :to="{ path: '/pages/annual-financials/4' }" mini-icon="A" text="Annual Financials" />
              <sidenav-item :to="{ path: '/pages/financial-models/4' }"  mini-icon="F" text="Financial Models" />
              <sidenav-item :to="{ path: '/pages/quarterly-reports/4' }" mini-icon="Q" text="Quarterly Reports" />
            </ul>
          </template>
        </sidenav-collapse>
      </li> -->

    <!-- END PAGES -->
      
    <!-- USER SETTINGS -->
<li class="nav-item">
        <sidenav-collapse
          collapse-ref="userExamples"
          nav-text="Communications"
          :class="getRoute() === 'news' ? 'active' : ''"
        >
          <template #icon>
            <i class="ni ni-ui-04 text-info text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <sidenav-item :to="{ name: 'News and Updates List' }" mini-icon="K" text="News & Updates" />
            </ul>
          </template>
        </sidenav-collapse>
      </li>

    </ul>
  </div>
</template>
